/**
 * Created by lu on 2018/5/8.
 */
var nb = require('../../../nb');
module.exports = nb.define({
    parent: require('../Dialog'),
    slot: {
        content: ['html', {
            'class': 'login-info',
            $html: [{
                'class': 'page-title',
                $text: nb.bind('title')
            }, {
                $type: require('../../../page/login/view/Form'),
                $model: 'form'
            }, {
                'class': 'go-register',
                $html: [{
                    'class': 'no-num',
                    tag: 'span',
                    $text: nb.bind('num')
                }, {
                    'class': 'click-register',
                    tag: 'a',
                    href: 'register.html',
                    $text: nb.bind('register')
                }]
            }]

        }]
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/view/modal/login/Login.js
// module id = 515
// module chunks = 6